// @flow

let instance;

export function getGooglePayClientInstance(): ?GooglePayPaymentsClient {
  if (!instance) {
    instance = getGooglePayClient();
  }
  return instance;
}

function getGooglePayClient(): ?GooglePayPaymentsClient {
  if (hasGooglePaySupport()) {
    return new window.google.payments.api.PaymentsClient({
      environment: ENV_CONSTANTS.ENV === 'production'
        ? 'PRODUCTION'
        : 'TEST',
    });
  }

  return null;
}

function hasGooglePaySupport(): bool {
  return Boolean(
    window.google &&
    window.google.payments &&
    window.google.payments.api &&
    window.google.payments.api.PaymentsClient
  );
}
